import React from 'react';

import {FolderActionsButton} from 'app/components/general/FolderActionsButton';
import {getMediaImage} from 'app/general/structures/UserContentContainer/nodeProcessors/MakeImagesZoomable/UserContentImage';
import {KBTreeDeleteItemContextProvider} from 'app/kbs/components/KBEditPage/KBTree/KBTreeDeleteItemModal';
import {useAccountSettingsState} from 'app/settings/api';
import {getDashboardFolderDetailURL} from 'app/urls';
import {removeMediaPath} from 'app/utils/fineuploader';

import {useCurrentFolder} from './FolderContext';
import {GenericWidget} from './GenericWidget';

import type {FolderSerializedType} from 'sweet-types';

interface Props {
  object: FolderSerializedType;
  refetchFolders: () => Promise<unknown>;
}

export function FolderWidget({object, refetchFolders}: Props) {
  const url = getDashboardFolderDetailURL(object.name, object.hashid);
  const settings = useAccountSettingsState().data!;

  const {folder: parentFolder} = useCurrentFolder();

  const thumbnail = object.description.images[0]?.image_ref
    ? removeMediaPath(
        object.description.images[0].image_ref,
        settings.MEDIA_URL
      )
    : undefined;

  const [src] = getMediaImage(
    thumbnail,
    '',
    settings.MEDIA_URL_READ,
    settings.MEDIA_URL,
    thumbnail,
    null,
    'small'
  );

  return (
    <GenericWidget
      name={object.name}
      contentType="folder"
      url={url}
      thumbnail={src}
      actionsButton={
        <KBTreeDeleteItemContextProvider>
          <FolderActionsButton
            object={object}
            allowedTeams={parentFolder?.teams ?? []}
            refreshData={refetchFolders}
          />
        </KBTreeDeleteItemContextProvider>
      }
    />
  );
}
